import { Injectable } from '@angular/core';
import type { ErrorMapping, ErrorRule } from '@core/error-handler/models/error-mapping.model';

@Injectable()
export abstract class BaseErrorMappingService implements ErrorMapping {
  protected abstract rules: ErrorRule[];

  getErrorRules(): ErrorRule[] {
    return this.rules;
  }

  appliesTo(url: string): boolean {
    return this.rules.some((rule) => {
      if (rule.pattern instanceof RegExp) {
        return rule.pattern.test(url);
      }
      return url.includes(rule.pattern);
    });
  }

  getMatchingRule(url: string): ErrorRule | null {
    return (
      this.rules.find((rule) => {
        if (rule.pattern instanceof RegExp) {
          return rule.pattern.test(url);
        }
        return url.includes(rule.pattern);
      }) || null
    );
  }
}
